export default "__VITE_ASSET__nfnPFDnt__"